import {normalize} from './../../util/utils';
import * as types from '../../actions/actiontypes';

export default function reducer(state = {}, action) {
	switch (action.type) {
		case types.GET_ACCOUNTS:
			if (action.response && action.response.data && !action.isManageAccounts) {
				const _assertions = action.response.data
					.flatMap((account) => account.assertions || [])
					.map((assertion) => ({
						...assertion,
						risks: assertion.risks?.map((risk) => risk.id)
					}));
				const newState = action.mergeStrategy
					? normalize(_assertions, undefined, state, action.mergeStrategy)
					: normalize(_assertions);
				return newState;
			}
			return state;
		default:
			return state;
	}
}
